import React, { useContext, useState } from "react";

import { useTranslation } from "react-i18next";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import "../../styles/styles.css";

const StudyDetails = ({ viewportData, isMPR = false}) => {
  const { getConsistentDateFormat } = useContext(studyReportContext);
  const { t } = useTranslation();
  return (
    <>
      <div className="viewport-overlay-study" style={{maxWidth:isMPR ? "200px" : ""}}>
        {viewportData && (
          <>
            <span style={{ lineHeight: "15px" }}>
              <span className="viewport-overlay-key">
                {t("viewer.overlay.study-id")}:{" "}
              </span>
              <span className="viewport-overlay-value">
                {viewportData?.studyIdDisplay === "" || viewportData?.studyIdDisplay === null || viewportData?.studyIdDisplay === undefined ? "-" : viewportData?.studyIdDisplay}, {viewportData?.studyDescription}
              </span>
            </span>
            <span style={{ lineHeight: "20px" }}>
              <span className="viewport-overlay-value">
                {getConsistentDateFormat(viewportData?.studyDate)}
              </span>
            </span>
            


            {/* <div>Study Id: {studyResponseData?.id}</div>
            <div>Description: {studyResponseData?.studyDescription}</div>
            <div>Study Date: {studyResponseData?.studyDateDisplay}</div> */}
            {/* <div>Study Id: {patientResponseData?.id}</div>
            <div>Description: {patientResponseData?.studyDescription}</div>
            <div>Study Date: {patientResponseData?.studyDateDisplay}</div> */}
          </>
        )}
      </div>
    </>
  );
};

export default StudyDetails;
